import cx from 'classnames';
import React from 'react';

import * as styles from './Typography.module.css';

const H = ({
	children,
	level,
	as,
	spacing,
	className = '',
	align,
	color,
}: {
	children: React.ReactNode;
	level: 0 | 1 | 2 | 3 | 4 | 5 | 6;
	as?: React.ElementType;
	spacing?: 'none' | 'sm' | 'md' | 'lg';
	align?: string;
	color?: 'blue' | 'white' | 'orange' | 'green';
	className?: string;
}): JSX.Element => {
	const Component = React.useMemo(() => {
		if (as) return as;
		return `h${level || 1}`;
	}, [level, as]);

	const componentClassName = cx(styles.heading, {
		h0: level === 0,
		h1: level === 1,
		h2: level === 2,
		h3: level === 3,
		h4: level === 4,
		h5: level === 5,
		h6: level === 6,
		[styles[`${spacing}Spacing`]]: spacing,
		[styles[`${align}Align`]]: align,
		[styles[`${color}Color`]]: color,
	});

	return (
		<Component
			className={cx(componentClassName, {
				[className]: !!className,
			})}
		>
			{children}
		</Component>
	);
};

export default H;
